import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Newsletter List", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editDialog = true)),
        color: "primary",
        variant: "flat"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createTextVNode(" Create New ", -1))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_data_table, {
      class: "mt-6",
      items: _ctx.lettersResponse ? _ctx.lettersResponse.items : [],
      headers: _ctx.headers,
      loading: _ctx.loading,
      "hide-default-footer": "",
      "items-per-page": -1,
      color: "primary"
    }, {
      [`item.category`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.design.category == "healthLetter" ? "Health Newsletter" : "School Newsletter"), 1)
      ]),
      [`item.edit`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          to: `/letter/${item.letterId}`,
          color: "primary",
          small: "",
          variant: "flat"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Edit ", -1)
          ]))]),
          _: 1
        }, 8, ["to"])
      ]),
      [`item.duplicate`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.duplicateLetter(item.letterId)),
          color: "primary",
          small: "",
          variant: "outlined"
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Duplicate ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      [`item.delete`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.deleteLetter(item.letterId)),
          style: {"background-color":"#ff5252","color":"#ffffff","font-weight":"bold"},
          small: "",
          variant: "outlined"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Delete ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 2
    }, 1032, ["items", "headers", "loading"]),
    (_ctx.lettersResponse)
      ? (_openBlock(), _createBlock(_component_v_pagination, {
          key: 0,
          class: "mt-6",
          modelValue: _ctx.page,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
          onInput: _ctx.pageClick,
          length: Math.ceil(_ctx.lettersResponse.total / _ctx.searchFilters.limit)
        }, null, 8, ["modelValue", "onInput", "length"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editDialog) = $event)),
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Newsletter", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" Color ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.templateInput.isFullColor,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.templateInput.isFullColor) = $event)),
                              items: _ctx.fullcolorItems,
                              density: "compact",
                              "hide-details": "",
                              variant: "outlined",
                              disabled: _ctx.loading
                            }, null, 8, ["modelValue", "items", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" Month ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.templateInput.month,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.templateInput.month) = $event)),
                              items: _ctx.monthItems,
                              density: "compact",
                              "hide-details": "",
                              variant: "outlined",
                              suffix: "",
                              disabled: _ctx.loading
                            }, null, 8, ["modelValue", "items", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.templateResponse)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateResponse.designs, (item, i) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                cols: "3",
                                key: i
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: `/letter?designSlug=${item.designSlug}&month=${_ctx.templateInput.month}&isFullColor=${_ctx.templateInput.isFullColor}&category=${item.category}&url=${item.url}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_img, {
                                        src: item.url,
                                        contain: ""
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}